<div class="text__small">
  <sbnb-icon
    icon="check"
    class="payout-icon-ok"
    *ngIf="
      payout.provider === PayoutMethodProvider.STRIPE_OAUTH ||
      (payout.provider === PayoutMethodProvider.ADYEN &&
        payout.adyen.status === AdyenPayoutMethodStatus.VALID)
    "></sbnb-icon>

  <!-- Temporarily hiding this until we want to show the button -->
  <!-- If you want to show the button, check that !payout.adyen.missing_tin in the if statement above -->
  <!-- <span *ngIf="payout.provider === PayoutMethodProvider.ADYEN && payout.adyen.status === AdyenPayoutMethodStatus.VALID && payout.adyen.missing_tin"
    class="raspberry-darker clickable">
    Taxpayer information required
  </span> -->

  <span
    *ngIf="payout.provider === PayoutMethodProvider.ADYEN && payout.adyen.status === AdyenPayoutMethodStatus.INVALID"
    class="raspberry-darker clickable"
    fxLayoutAlign="start center"
    fxLayoutGap="6px"
    [satPopoverAnchor]="p"
    (mouseenter)="p.open()"
    (mouseleave)="p.close()"
    (click)="$event.preventDefault(); $event.stopPropagation(); verificationClicked.emit()">
    <span>Verification required</span>
    <sbnb-icon *ngIf="payout.adyen?.verification_errors" icon="details" class="text-smoke-darker"></sbnb-icon>
    <sat-popover verticalAlign="below" horizontalAlign="start" #p>
      <div class="popover">
        <p *ngFor="let error of payout.adyen.verification_errors">
          {{ error }}
        </p>
      </div>
    </sat-popover>
  </span>

  <span
    *ngIf="
      payout.provider === PayoutMethodProvider.ADYEN &&
      (payout.adyen.status === AdyenPayoutMethodStatus.PENDING || payout.adyen.status === null)
    "
    class="italic">
    Pending
  </span>

  <span
    *ngIf="payout.provider === PayoutMethodProvider.ADYEN && payout.adyen.status === AdyenPayoutMethodStatus.REJECTED"
    class="smoke-darker">
    Verification Failed
  </span>
</div>
